import {
    SHOW_LOGIN_MODAL,
    HIDE_LOGIN_MODAL,
    SHOW_SIGN_IN_GUEST_MODAL,
    HIDE_SIGN_IN_GUEST_MODAL,
    SHOW_CREATE_ACCOUNT_MODAL,
    HIDE_CREATE_ACCOUNT_MODAL,
    SHOW_RESET_MODAL,
    HIDE_RESET_MODAL
} from '../../actions/actionTypes';

const initialState = {
    showSignInGuestModal: false,
    showLoginModal: false,
    showCreateAccountModal: false,
    showResetModal: false
};

const modalReducer = (state = initialState, action) => {
    if (typeof state === 'undefined') {
        return initialState;
    }
    switch (action.type) {
        case SHOW_LOGIN_MODAL:
            return Object.assign({}, state, {
                showLoginModal: true
            });
        case HIDE_LOGIN_MODAL:
            return Object.assign({}, state, {
                showLoginModal: false
            });
        case SHOW_SIGN_IN_GUEST_MODAL:
            return Object.assign({}, state, {
                showSignInGuestModal: true
            });
        case HIDE_SIGN_IN_GUEST_MODAL:
            return Object.assign({}, state, {
                showSignInGuestModal: false
            });
        case SHOW_CREATE_ACCOUNT_MODAL:
            return Object.assign({}, state, {
                showCreateAccountModal: true
            });
        case HIDE_CREATE_ACCOUNT_MODAL:
            return Object.assign({}, state, {
                showCreateAccountModal: false
            });
        case SHOW_RESET_MODAL:
            return Object.assign({}, state, {
                showResetModal: true
            });
        case HIDE_RESET_MODAL:
            return Object.assign({}, state, {
                showResetModal: false
            });
        default:
            return state;
    }
};

export default modalReducer;
